import script from "./map-element-wrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./map-element-wrapper.vue?vue&type=script&setup=true&lang=ts"

import "./map-element-wrapper.vue?vue&type=style&index=0&id=8a0e9328&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a0e9328"]])

export default __exports__